import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Disqus from 'disqus-react';

import {
  formatAbreviatedMonthDayAndYear,
  formatIsoDate,
} from '../../../lib/FormatUtils';

import DefaultBanner from '../../../components/DefaultBanner';
import AspectImage from '../../../components/AspectImage';

import s from './BlogPost.scss';

class BlogPost extends React.Component {
  static propTypes = {
    blogData: PropTypes.shape({
      seo_title: PropTypes.string,
    }),
  };

  static defaultProps = {
    blogData: null,
  };

  render() {
    const { blogData } = this.props;

    if (blogData) {
      const disqusShortname = 'flux-tech';
      const disqusConfig = {
        url: process.env.BROWSER
          ? window.location.href
          : `https://fluxtech.co/blog/${blogData.url}`,
        identifier: blogData.slug,
        title: blogData.seo_title,
      };

      let startup = false;
      blogData.tags.forEach(tag => {
        if (tag.slug === 'startup') {
          startup = true;
        }
      });

      return (
        <section itemScope itemType="https://schema.org/BlogPosting">
          <meta
            content={formatIsoDate(blogData.published)}
            itemProp="datePublished"
          />
          <meta content={blogData.featured_image} itemProp="image" />
          <div className={s.container}>
            <DefaultBanner
              breadcrumb={
                <ul
                  className="breadcrumb"
                  itemScope
                  itemType="https://schema.org/BreadcrumbList"
                >
                  <li
                    itemProp="itemListElement"
                    itemScope
                    itemType="https://schema.org/ListItem"
                  >
                    <a
                      href="https://fluxtech.co/"
                      itemProp="item"
                      itemType="https://schema.org/Thing"
                    >
                      <span itemProp="name">Home</span>
                    </a>
                    <meta content="0" itemProp="position" />
                  </li>
                  <li
                    itemProp="itemListElement"
                    itemScope
                    itemType="https://schema.org/ListItem"
                  >
                    <a
                      href="https://fluxtech.co/blog/"
                      itemProp="item"
                      itemType="https://schema.org/Thing"
                    >
                      <span itemProp="name">Blog</span>
                      <meta content="1" itemProp="position" />
                    </a>
                  </li>
                  <li>{blogData.seo_title}</li>
                </ul>
              }
              trim
            />

            <article className={s.stripCenter}>
              <div className={s.contentLeft}>
                <div className={s.featuredImage}>
                  <AspectImage
                    altText={blogData.meta_description}
                    aspectRatio="16:9"
                    src={blogData.featured_image}
                    width="100%"
                  />
                </div>

                <h1 itemProp="headline">{blogData.seo_title}</h1>
                <h2>{blogData.summary}</h2>

                <div
                  className={s.article}
                  /* eslint-disable-next-line */
                  dangerouslySetInnerHTML={{ __html: blogData.body }}
                />
                <div className="article">
                  <Disqus.CommentCount
                    config={disqusConfig}
                    shortname={disqusShortname}
                  >
                    Comments
                  </Disqus.CommentCount>
                  <Disqus.DiscussionEmbed
                    config={disqusConfig}
                    shortname={disqusShortname}
                  />
                </div>

                <div
                  itemProp="publisher"
                  itemScope
                  itemType="https://schema.org/Organization"
                >
                  <div
                    itemProp="logo"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                  >
                    <meta
                      content="http://www.mycorp.com/images/uncompressed/amp-regulation-logo.jpg"
                      itemProp="url"
                    />
                    <meta content="600" itemProp="width" />
                    <meta content="60" itemProp="height" />
                  </div>
                  <meta content="Flux Tech" itemProp="name" />
                </div>
              </div>

              {blogData.author.linkedin_url ? (
                <a
                  className={s.authorContainer}
                  href={blogData.author.linkedin_url}
                >
                  <div
                    className={s.profilePhoto}
                    style={{
                      backgroundImage: `url(${blogData.author.profile_image})`,
                    }}
                  >
                    <img
                      alt="Authors profile"
                      src={blogData.author.profile_image}
                    />
                  </div>
                  <div>
                    <p itemProp="name">{`${blogData.author.first_name} ${
                      blogData.author.last_name
                    }`}</p>
                    <time>
                      {formatAbreviatedMonthDayAndYear(blogData.published)}
                    </time>
                  </div>
                </a>
              ) : (
                <div
                  className={s.authorContainer}
                  itemProp="author"
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <div
                    className={s.profilePhoto}
                    style={{
                      backgroundImage: `url(${blogData.author.profile_image})`,
                    }}
                  >
                    <img
                      alt="Authors profile"
                      src={blogData.author.profile_image}
                    />
                  </div>
                  <div>
                    <p itemProp="name">{`${blogData.author.first_name} ${
                      blogData.author.last_name
                    }`}</p>
                    <time>
                      {formatAbreviatedMonthDayAndYear(blogData.published)}
                    </time>
                  </div>
                </div>
              )}
            </article>
          </div>

          <div className={s.subscribe} id="mc_embed_signup">
            <form
              action="https://app.us20.list-manage.com/subscribe/post?u=37a65bdc2a5eefb09d7368727&amp;id=1566716fd7&amp;tag=startup"
              className="validate"
              id="mc-embedded-subscribe-form"
              method="post"
              name="mc-embedded-subscribe-form"
              noValidate
              target="_blank"
            >
              <div id="mc_embed_signup_scroll">
                {startup ? (
                  <h2>Subscribe for monthly business content</h2>
                ) : (
                  <h2>Subscribe for monthly technical content</h2>
                )}
                <div className={s.indicatesRequired}>
                  <span className={s.asterisk}>*</span> indicates required
                </div>
                <div className={s.fieldGroup}>
                  <label htmlFor="mce-EMAIL">
                    Email Address <span className={s.asterisk}>*</span>
                    <input
                      defaultValue=""
                      id="mce-EMAIL"
                      name="EMAIL"
                      type="email"
                    />
                  </label>
                </div>
                <div className={s.fieldGroup}>
                  <label htmlFor="mce-FNAME">
                    First Name{' '}
                    <input
                      defaultValue=""
                      id="mce-FNAME"
                      name="FNAME"
                      type="text"
                    />
                  </label>
                </div>
                <div className={s.fieldGroup}>
                  <label htmlFor="mce-LNAME">
                    Last Name{' '}
                    <input
                      defaultValue=""
                      id="mce-LNAME"
                      name="LNAME"
                      type="text"
                    />
                  </label>
                </div>
                <div className={s.fieldGroup} style={{ display: 'none' }}>
                  <label htmlFor="mce-MMERGE3">
                    <input
                      defaultValue={startup ? 'Startup' : 'Technical'}
                      id="mce-MMERGE3"
                      name="MMERGE3"
                      type="text"
                    />
                  </label>
                </div>
                <div className="clear" id="mce-responses">
                  <div id="mce-error-response" style={{ display: 'none' }} />
                  <div id="mce-success-response" style={{ display: 'none' }} />
                </div>
                <div
                  aria-hidden="true"
                  style={{ position: 'absolute', left: '-5000px' }}
                >
                  <input
                    defaultValue=""
                    name="b_37a65bdc2a5eefb09d7368727_1566716fd7"
                    tabIndex="-1"
                    type="text"
                  />
                </div>
                <div>
                  <input
                    className={s.button}
                    id="mc-embedded-subscribe"
                    name="subscribe"
                    type="submit"
                    value="Subscribe"
                  />
                </div>
              </div>
            </form>
          </div>
        </section>
      );
    }
    return <div>Loading...</div>;
  }
}

const mapDispatchToProps = dispatch_unused => ({});

const mapStateToProps = state => state.all;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(s)(BlogPost));
